module.exports = __webpack_public_path__ + "static/media/11.b49b4ade.jpg";